var React = require('react');

function CircleFilled8x8 (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"4","cy":"4","r":"4","fill":"currentColor"}));
}

CircleFilled8x8.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none"};

module.exports = CircleFilled8x8;

CircleFilled8x8.default = CircleFilled8x8;
